import type * as React from 'react';
import { cn } from '@/utils/style';
import { ShadcnTooltip, TooltipContent, TooltipTrigger } from './shadcn/Tooltip';

interface TooltipProps {
  text: string;
  children: React.ReactNode;
  className?: string;
}

export function Tooltip(props: TooltipProps) {
  const { text, children, className } = props;

  return (
    <ShadcnTooltip>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent className={cn('max-w-xs', className)}>
        <p>{text}</p>
      </TooltipContent>
    </ShadcnTooltip>
  );
}
